export const MASS_DE_PSEUDO_FAILURE = 'MASS_DE_PSEUDO_FAILURE';

export const massDePseudoFailure = error => ({
    type: MASS_DE_PSEUDO_FAILURE,
    payload: error,
    error: true,
});
